import { render, staticRenderFns } from "./tagDetails.vue?vue&type=template&id=1a9c01c2&scoped=true&"
import script from "./tagDetails.vue?vue&type=script&lang=js&"
export * from "./tagDetails.vue?vue&type=script&lang=js&"
import style0 from "./tagDetails.vue?vue&type=style&index=0&id=1a9c01c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a9c01c2",
  null
  
)

component.options.__file = "tagDetails.vue"
export default component.exports